import LoaderGif from './loading-animation.gif';

export const GIFS = {
  LoaderGif,
};
